// extracted by mini-css-extract-plugin
module.exports = {"bestseller-loader__container":"product-card-loader_bestseller-loader__container__WNTsZ","bestseller-loader__overflow":"product-card-loader_bestseller-loader__overflow__gaeas"};